export default __webpack_public_path__ + "static/wspieraj-niezaklocony-rozwoj-twojej-pociechy-a092ae3d8ca1539020c439621bb57a37.jpg";